<div class="dialog-container">
  <h2 mat-dialog-title>{{ data.title }}</h2>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-message">{{ data.message || data.msg }}</p>

    <div *ngIf="data.requireInput" class="input-section">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ data.inputLabel || 'Observações' }}</mat-label>
        <textarea
          matInput
          [(ngModel)]="inputValue"
          [placeholder]="data.inputPlaceholder || ''"
          [required]="data.inputRequired || data.requireInput"
          rows="3"
          maxlength="500">
        </textarea>
        <mat-hint align="end">{{ inputValue?.length || 0 }}/500</mat-hint>
        <mat-error *ngIf="(data.inputRequired || data.requireInput) && (!inputValue || inputValue.trim().length === 0)">
          Este campo é obrigatório
        </mat-error>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button
      *ngIf="data.cancelButtonText || data.dismissLabel"
      mat-stroked-button
      [mat-dialog-close]="false"
      class="dismiss-button">
      {{ data.cancelButtonText || data.dismissLabel }}
    </button>

    <button
      *ngIf="data.confirmButtonText || data.confirmLabel"
      mat-raised-button
      color="primary"
      [disabled]="(data.requireInput || data.inputRequired) && (!inputValue || inputValue.trim().length === 0)"
      (click)="onConfirm()"
      class="confirm-button">
      {{ data.confirmButtonText || data.confirmLabel }}
    </button>

    <button
      *ngIf="data.warninLabel"
      mat-raised-button
      color="warn"
      [mat-dialog-close]="true"
      class="warning-button">
      {{ data.warninLabel }}
    </button>
  </mat-dialog-actions>
</div>
